var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5V18.4108L4.9006 17.4985C5.17415 17.3672 5.49252 17.3672 5.76606 17.4985L8.66667 18.8908L11.5673 17.4985C11.8408 17.3672 12.1592 17.3672 12.4327 17.4985L15.3333 18.8908L18.2339 17.4985C18.5075 17.3672 18.8258 17.3672 19.0994 17.4985L21 18.4108V5H3ZM1.55155 3.51293C1.8982 3.18014 2.35998 3 2.83333 3H21.1667C21.64 3 22.1018 3.18014 22.4485 3.51293C22.7965 3.84705 23 4.30913 23 4.8V20C23 20.3437 22.8235 20.6633 22.5326 20.8464C22.2417 21.0294 21.8771 21.0503 21.5673 20.9015L18.6667 19.5092L15.7661 20.9015C15.4925 21.0328 15.1741 21.0328 14.9006 20.9015L12 19.5092L9.0994 20.9015C8.82585 21.0328 8.50748 21.0328 8.23394 20.9015L5.33333 19.5092L2.43273 20.9015C2.12287 21.0503 1.75834 21.0294 1.46743 20.8464C1.17652 20.6633 1 20.3437 1 20V4.8C1 4.30913 1.2035 3.84705 1.55155 3.51293ZM5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9C19 9.55228 18.5523 10 18 10H6C5.44772 10 5 9.55228 5 9ZM5 13C5 12.4477 5.44772 12 6 12H18C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14H6C5.44772 14 5 13.5523 5 13Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateOrders);
export default __webpack_public_path__ + "static/media/create_orders.49951d2014b30f7c5397133548b7ba7e.svg";
export { ForwardRef as ReactComponent };